module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "olst-field-checkbox-label"
  }, [_c('label', {
    staticClass: "olst-field-checkbox-label-group",
    class: {
      'olst-field-checkbox-label-group-open': _vm.hideFilters
    },
    attrs: {
      "for": _vm.name
    },
    domProps: {
      "textContent": _vm._s(_vm.getFilterName)
    },
    on: {
      "click": _vm.labelClicked
    }
  })]), _c('div', [_vm._l((_vm.checkboxes), function(checkbox, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.hideFilters),
        expression: "!hideFilters"
      }],
      class: {
        'olst-checkbox-all checkbox-check-all': checkbox.isAllCheckbox, 'olst-checkbox': !checkbox.isAllCheckbox
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkedCheckboxed),
        expression: "checkedCheckboxed"
      }],
      attrs: {
        "type": "checkbox",
        "name": checkbox.key,
        "id": checkbox.key
      },
      domProps: {
        "value": checkbox.key,
        "checked": Array.isArray(_vm.checkedCheckboxed) ? _vm._i(_vm.checkedCheckboxed, checkbox.key) > -1 : (_vm.checkedCheckboxed)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.checkedCheckboxed,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = checkbox.key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.checkedCheckboxed = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.checkedCheckboxed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkedCheckboxed = $$c
          }
        }, function($event) {
          checkbox.onClick(checkbox.key)
        }]
      }
    }), _c('label', {
      staticClass: "olst-field-checkbox-label olst-field-checkbox-label-item",
      attrs: {
        "for": checkbox.key
      },
      domProps: {
        "textContent": _vm._s(checkbox.label)
      }
    })])
  }), _c('div', {
    staticClass: "olst-clear"
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-621932c5!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@oliverstore/core-rendering-engine/src/views/components/inputs/multiple_choices/CheckboxListWithAllOption.vue
// module id = 357
// module chunks = 1